import * as React from 'react';
import { AmenityBody } from './internals/amenity-body';
import { AmenityTitle } from './internals/amenity-title';

export interface AmenitySectionProps {
  section: {
    title: string;
    body: string[];
  };
  index: number;
  category: string;
}

export const AmenitySection: React.FunctionComponent<AmenitySectionProps> = ({ index, category, section }) => (
  <div className="policies__section--text all-y-padding-three" key={`${category}-${index}`}>
    <AmenityTitle category={category} title={section.title} />
    {section.body.map((text, bodyIndex) => (
      <AmenityBody key={`amenity-body-${bodyIndex}`} text={text} index={bodyIndex} category={category} />
    ))}
  </div>
);
